module.exports = __webpack_public_path__ + "img/00011.ff72542f.webp";